<template>
    <div id="SupportRequest">
      <TicketSubmitDialog v-if="statusBoxState.shown">
        <h3 slot="header">{{statusBoxState.title}}</h3>
        <div slot="body">
          <div>
            <span>{{statusBoxState.message}}</span>
          </div>
          <br>
          <div v-for="progressBar in statusBoxState.progressBars" :key="progressBar.id" style="{ margin-bottom: 1em }">
            <span>{{progressBar.name}}</span>
            <PSProgressBar :progressWidth="progressBar.percentComplete"></PSProgressBar>
          </div>
        </div>
        <div slot="footer">
          <button class="Button" v-for="button in statusBoxState.buttons" :key="button.id" @click="button.action" v-text="button.text"></button>
          <button v-if="statusBoxState.done" class="modal-default-button Button" @click="goHome()">
            OK
          </button>
        </div>
      </TicketSubmitDialog>
      <div class="PageHeader">
        <h2 class="PageHeader__subheading">{{$t("contactFormHeader")}}</h2>
      </div>
      <div class="Form" :key="$parent.config">
        <div class="FormGroup" ref="parkSelect">
          <label for="parkSelect">{{$t("parkAttraction")}}</label>
          <span>{{$t("parkAttractionHint")}}</span>
          <model-list-select id="parkSelect" :list="siteOptions.options" option-text="name" option-value="at_field" v-model="formData.site.value" :placeholder="$t('beginTyping')" @input="siteSelected"></model-list-select>
          <div class="Form__Error" v-if="formData.site.invalid">{{$t('errorChooseSite')}}</div>
        </div>
        <transition name="slide">
          <div v-if="siteOptions.selected" class="FormGroup" ref="rideSelect" >
            <label for="rideSelect">{{$t("cameraRide")}}</label>
            <span>{{$t("cameraRideHint")}}</span>
            <model-list-select :isDisabled="!formData.ride.enabled" id="rideSelect" :list="rideOptions" option-text="name" option-value="key" v-model="formData.ride.value" :placeholder="$t('beginTyping')" @input="formValueChanged"></model-list-select>
            <div class="Form__Error" v-if="formData.ride.invalid">{{formData.ride.error}}</div>
          </div>
        </transition>
        <div class="FormGroup" ref="issueSelect">
          <label for="issueSelect">{{$t("issue")}}</label>
          <span>{{$t("issueHint")}}</span>
          <model-list-select id="issueSelect" :list="issueOptions" option-text="name" option-value="id" v-model="formData.issue.value" :placeholder="$t('beginTyping')" @input="formValueChanged"></model-list-select>
          <div class="Form__Error" v-if="formData.issue.invalid">{{formData.issue.error}}</div>
        </div>
        <div class="FormGroup" ref="dateSelect">
          <label for="dateSelect">{{$t("dateOfVisit")}}</label>
          <span>{{$t("dateOfVisitHint")}}</span>
          <datepicker id="dateSelect" v-model="formData.date.value" :disabledDates="{from: new Date()}" :placeholder="$t('dateSelectPlaceHolder')" @selected="formValueChanged"/>
          <div class="Form__Error" v-if="formData.date.invalid">{{$t('errorChooseDate')}}</div>
        </div>
        <!--Name, Email, Digipass Code, Message, Attachment-->
        <div class="FormGroup" ref="firstNameInput">
          <label for="firstNameInput">{{$t("firstName")}}</label>
          <input id="firstNameInput" type="text" v-model="formData.firstName.value" @change="formValueChanged"/>
          <div class="Form__Error" v-if="formData.firstName.invalid">{{$t('errorFirstName')}}</div>
        </div>
        <div class="FormGroup" ref="lastNameInput">
          <label for="lastNameInput">{{$t("lastName")}}</label>
          <input id="lastNameInput" type="text" v-model="formData.lastName.value" @change="formValueChanged"/>
          <div class="Form__Error" v-if="formData.lastName.invalid">{{$t('errorLastName')}}</div>
        </div>
        <div class="FormGroup" ref="emailInput">
          <label for="emailInput">{{$t("email")}}</label>
          <input id="emailInput" type="email" v-model="formData.email.value" @change="formValueChanged"/>
          <div class="Form__Error" v-if="formData.email.invalid">{{$t('errorMissingEmail')}}</div>
          <div class="Form__Error" v-else-if="formData.email.missing">{{$t('errorInvalidEmail')}}</div>
        </div>
        <div class="FormGroup" ref="contactNumberInput">
          <label for="contactNumberInput">{{$t("contactNumber")}}</label>
          <input id="contactNumberInput" type="text" v-model="formData.contactNumber.value" @change="formValueChanged"/>
          <div class="Form__Error" v-if="formData.contactNumber.invalid">{{$t('errorMissingContactNumber')}}</div>
        </div>
        <div class="FormGroup" ref="digiPassInput">
          <label for="digiPassInput">{{$t("digiPassCode")}}</label>
          <span>{{$t("digiPassCodeHint")}}</span>
          <input id="digiPassInput" type="text" v-model="formData.digipassCode.value" @change="formValueChanged"/>
          <div class="Form__Error" v-if="formData.digipassCode.invalid">{{formData.digipassCode.error}}</div>
        </div>
        <div class="FormGroup" ref="photoCodeInput">
          <label for="photoCodeInput">{{$t("photoCode")}}</label>
          <span>{{$t("photoCodeHint")}}</span>
          <input id="photoCodeInput" type="text" v-model="formData.photoCode.value" @change="formValueChanged"/>
          <div class="Form__Error" v-if="formData.photoCode.invalid">{{formData.photoCode.error}}</div>
        </div>
        <div class="FormGroup" ref="messageInput">
          <label for="messageInput">{{$t("message")}}</label>
          <span>{{$t("messageHint")}}</span><br>
          <textarea id="messageInput" v-model="formData.message.value" @change="formValueChanged"></textarea>
          <div class="Form__Error" v-if="formData.message.invalid">{{$t('errorNoMessage')}}</div>
        </div>
        <div class="FormGroup">
          <label for="attachments">{{$t("attachments")}}</label>
          <span>{{$t("attachmentsHint")}}</span><br>
          <div class="dropbox">
            <input type="file" multiple id="attachments" class="input-file" ref="fileUploader" @change="processFile"/>
            <p v-if="attachments.length === 0">
              {{$t("attachmentsCaption")}}
            </p>
            <div class="fileAttachment" v-for="attachment in attachments" :key="attachment.fileName">{{attachment.fileName}}</div>
          </div>
        </div>
        <div class="FormGroup">
          <button id="submit" v-on:click="submit()" ref="submitButton">Submit</button>
        </div>
      </div>
    </div>
</template>

<script>
import { ModelListSelect } from 'vue-search-select'
import Datepicker from 'vuejs-datepicker'
import TicketSubmitDialog from './TicketSubmitDialog'
import PSProgressBar from './PSProgressBar'

let axios = require('axios');

export default {
  name: 'SubmitSupportRequest',
  components: {
    ModelListSelect,
    Datepicker,
    TicketSubmitDialog,
    PSProgressBar
  },
  async mounted() {
    if(this.$route.query.issue) {
      await this.$parent.getConfig(false)
    }
    
    this.siteOptions.options = this.$parent.config.Sites;
    this.issueOptions = this.$parent.config.Products;
    
    if(this.$route.query.issue) {
      this.formData.issue.value = this.$parent.config.Products.filter(p => p.id == this.$route.query.issue)[0]
    }

    this.$nextTick(() => {
      let state = this.$parent.getState();
      if (state.site !== undefined && state.site !== null) {
        this.formData.site.value = state.site;
        this.siteSelected(this.formData.site.value);
      }
      if (state.product !== undefined && state.issue !== null) {
        this.formData.issue.value = state.product;
      }
    });
  },
  data: function () {
    return {
      statusBoxState: this.initStatusBox(),
      ticketNumber: '',
      attachments: [],
      siteOptions: {
        options: [],
        selected: false
      },
      rideOptions: [],
      issueOptions: [],
      formData: {
        site: {
          value: {},
          invalid: false,
          error: '',
          ref: 'parkSelect'
        },
        ride: {
          value: {},
          invalid: false,
          error: '',
          enabled: true,
          ref: 'rideSelect'
        },
        issue: {
          value: {},
          invalid: false,
          error: '',
          ref: 'issueSelect'
        },
        date: {
          value: '',
          invalid: false,
          error: '',
          ref: 'dateSelect'
        },
        firstName: {
          value: '',
          invalid: false,
          error: '',
          ref: 'firstNameInput'
        },
        lastName: {
          value: '',
          invalid: false,
          error: '',
          ref: 'lastNameInput'
        },
        email: {
          value: '',
          invalid: false,
          missing: false,
          error: '',
          ref: 'emailInput'
        },
        contactNumber: {
          value: '',
          invalid: false,
          error: '',
          ref: 'contactNumberInput'
        },
        digipassCode: {
          value: '',
          invalid: false,
          error: ''
        },
        photoCode: {
          value: '',
          invalid: false,
          error: ''
        },
        message: {
          value: '',
          invalid: false,
          error: '',
          ref: 'messageInput'
        }
      },
      valid: true
    }
  },
  methods: {
    initStatusBox() {
      let statusBox = {
        title: this.$t('statusSubmittingSupportRequest'),
        message: this.$t('statusSendingTicket'),
        progressBars: [],
        buttons: [],
        done: false,
        shown: false
      };
      this.statusBoxState = statusBox;
      return statusBox;
    },
    siteSelected(value) {
      let rides = this.$parent.config.Rides.filter(ride => {
        return ride.site_id === value.id;
      });

      if (rides !== undefined && rides.length > 0) {
        this.rideOptions = rides;
        if (rides.length === 1) {
          this.formData.ride.value = rides[0];
          this.formData.ride.enabled = false;
        } else {
          this.formData.ride.value = {};
          this.formData.ride.enabled = true;
        }
        this.siteOptions.selected = true;
      } else {
        this.siteOptions.selected = false;
        this.formData.ride.value = {};
      }
      if (!this.valid) {
        this.validate(false);
      }
    },
    formValueChanged(value) {
      if (!this.valid) {
        this.validate(false);
      }
    },
    goHome() {
      this.$router.push('/');
    },
    submitSupportRequest: function () {
        let ticketData = {
          request: {
            requester: {
              name: `${this.formData.firstName.value} ${this.formData.lastName.value}`,
              email: this.formData.email.value
            },
            subject: this.formData.issue.value.name,
            comment: {
              body: `Site: ${this.formData.site.value.name} 
Region: ${this.formData.site.value.region} 
Unit: ${this.formData.ride.value.name} 
Phone: ${this.formData.contactNumber.value} 
DigipassCode: ${this.formData.digipassCode.value} 
PhotoCode: ${this.formData.photoCode.value} 
Visit Date: ${this.formData.date.value.toDateString()}
Description: ${this.formData.message.value}`
            },
            custom_fields: [
              {id: 360028914438, value: this.formData.email.value},
              {id: 360028915118, value: "picsolve.com"}
            ]
          }
        }

        if (this.attachments.length > 0) {
          this.statusBoxState.progressBars = [];
          this.statusBoxState.message = this.$t('statusAttachingFiles');
          let results = [];
          for (const i in this.attachments) {
            let attachment = this.attachments[i];
            this.statusBoxState.progressBars.push({id: `file${i}`, name: attachment.fileName, percentComplete: 0});
            results.push(this.uploadAttachment(attachment, (percentage) => {
              this.statusBoxState.progressBars[i].percentComplete = percentage
            }));
          }
          Promise.all(results)
            .then((values) => {
              console.log(values)
              let attachmentTokens = values.map(a => a.data.upload.token)
              console.log(attachmentTokens)
              ticketData.request.comment.uploads = attachmentTokens

              this.createTicket(ticketData).then((response) => {
                this.statusBoxState.progressBars = [];
                this.statusBoxState.title = 'Success!';
                this.statusBoxState.message = `Support request successfully received.  Ticket number: ${response.data.request.id}.  Please be aware that this is your ticket number, not a picture/video reference.`;
                this.statusBoxState.done = true;
              })
            }).catch((error) => {
              this.statusBoxState.title = 'Error'
              this.statusBoxState.message = error.message + '. Please try again.'
              this.$refs.submitButton.disabled = false
              this.statusBoxState.buttons.push({
                id: 'OK',
                text: this.$t('ok'),
                action: () => {
                  this.statusBoxState.shown = false;
                  this.initStatusBox();
                }
              });
            });
        } else {
            this.createTicket(ticketData).then((response) => {
              this.statusBoxState.progressBars = [];
              this.statusBoxState.title = this.$t('success');
              this.statusBoxState.message = `${this.$t('statusSuccessfullyReceived')}  ${this.$t('ticketNumber')}: ${response.data.request.id}.  ${this.$t('statusCaution')}`;
              this.statusBoxState.done = true;
          })
          .catch((error) => {
            this.statusBoxState.title = 'Error'
            this.statusBoxState.message = error.message + '. Please try again.'
            this.$refs.submitButton.disabled = false
            this.statusBoxState.buttons.push({
              id: 'OK',
              text: this.$t('ok'),
              action: () => {
                this.statusBoxState.shown = false;
                this.initStatusBox();
              }
            });
          })
        }
    },
    submit() {
      this.$refs.submitButton.disabled = true;
      this.validate(true);
      if (this.valid) {
        this.statusBoxState.shown = true;
        this.submitSupportRequest();
      } else {
        this.$refs.submitButton.disabled = false;
      }
    },
    validate(scrollToObject) {
      this.resetErrors();
      let scrolledToError = false;
      if (this.formData.site.value.name === undefined) {
        this.valid = false;
        this.formData.site.invalid = true;
        if (!scrolledToError && scrollToObject) {
          this.$refs[this.formData.site.ref].scrollIntoView();
          scrolledToError = true;
        }
      }
      if (this.formData.date.value === '') {
        this.valid = false;
        this.formData.date.invalid = true;
        if (!scrolledToError && scrollToObject) {
          this.$refs[this.formData.date.ref].scrollIntoView();
          scrolledToError = true;
        }
      }
      if (this.formData.firstName.value === '') {
        this.valid = false;
        this.formData.firstName.invalid = true;
        if (!scrolledToError && scrollToObject) {
          this.$refs[this.formData.firstName.ref].scrollIntoView();
          scrolledToError = true;
        }
      }
      if (this.formData.lastName.value === '') {
        this.valid = false;
        this.formData.lastName.invalid = true;
        if (!scrolledToError && scrollToObject) {
          this.$refs[this.formData.lastName.ref].scrollIntoView();
          scrolledToError = true;
        }
      }
      if (this.formData.email.value === '') {
        this.valid = false;
        this.formData.email.invalid = true;
        if (!scrolledToError && scrollToObject) {
          this.$refs[this.formData.email.ref].scrollIntoView();
          scrolledToError = true;
        }
      }
      if (!this.validEmail(this.formData.email.value)) {
        this.valid = false;
        this.formData.email.missing = true;
        if (!scrolledToError && scrollToObject) {
          this.$refs[this.formData.email.ref].scrollIntoView();
          scrolledToError = true;
        }
      }
      if (this.formData.contactNumber.value === '') {
        this.valid = false;
        this.formData.contactNumber.invalid = true;
        if (!scrolledToError && scrollToObject) {
          this.$refs[this.formData.contactNumber.ref].scrollIntoView();
          scrolledToError = true;
        }
      }
      if (this.formData.message.value === '') {
        this.valid = false;
        this.formData.message.invalid = true;
        if (!scrolledToError && scrollToObject) {
          this.$refs[this.formData.message.ref].scrollIntoView();
          scrolledToError = true;
        }
      }
    },
    resetErrors() {
      this.valid = true;
      this.formData.site.invalid = false;
      this.formData.ride.invalid = false;
      this.formData.issue.invalid = false;
      this.formData.date.invalid = false;
      this.formData.firstName.invalid = false;
      this.formData.lastName.invalid = false;
      this.formData.email.invalid = false;
      this.formData.email.missing = false;
      this.formData.contactNumber.invalid = false;
      this.formData.digipassCode.invalid = false;
      this.formData.photoCode.invalid = false;
      this.formData.message.invalid = false;
    },
    validEmail(email) {
      // eslint-disable-next-line
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    processFile() {
      this.attachments = [];
      let uploader = this.$refs.fileUploader;
      for (let x = 0; x < uploader.files.length; ++x) {
        let file = uploader.files[x];
        this.loadFile(file);
      }
    },
    loadFile(file) {
      let reader = new FileReader();
      reader.onload = () => {
        this.attachments.push({fileName: file.name, type: file.type, data: reader.result});
      };
      reader.readAsArrayBuffer(file);
    },
    uploadAttachment(attachment, percentageUpdate) {
      console.log(attachment)
      return axios({
        url: this.$parent.baseConfig.submitTicketUrl + 'uploads.json?filename=' + attachment.fileName,
        method: 'POST',
        headers: {
          'Content-Type': attachment.type
        },
        data: attachment.data,
        onUploadProgress: function(progressEvent) {
          if (percentageUpdate !== undefined) percentageUpdate(Math.round((progressEvent.loaded * 100) / progressEvent.total));
        }
      });
    },
    createTicket(ticketData) {
      return axios({
        url: this.$parent.baseConfig.submitTicketUrl + 'requests',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(ticketData),
        onUploadProgress: function(progressEvent) {
          this.statusBoxState.progressBars[0].percentComplete = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        }
      })
    }
  }
}
</script>

<style>
  div.ui.search.selection.dropdown {
    border: 1px solid black;
    box-sizing: border-box;
    color: #3c3c3b;
    display: block;
    font-family: Simplon,sans-serif;
    width: 100%;
    font-size: 1.5em;
    margin-bottom: .41667em;
    border-radius: 0 0 0 0;
    min-height: 0;
    padding: .375em;
  }
  input.search {
    padding-top: .2em !important;
    padding-left: .375em !important;
  }
  i.dropdown {
    padding: .375em !important;
  }
  .slide-enter-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: ease-in;
    -webkit-transition-timing-function: ease-in;
    -o-transition-timing-function: ease-in;
    transition-timing-function: ease-in;
  }

  .slide-leave-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  }

  .slide-enter-to, .slide-leave {
    max-height: 100px;
    overflow: hidden;
  }

  .slide-enter, .slide-leave-to {
    overflow: hidden;
    max-height: 0;
  }

  .dropbox {
    outline: 2px dashed grey;
    outline-offset: -0.6em;
    background: #ededed;
    color: dimgray;
    padding: 0.6em 0.6em 1.1em;
    min-height: 200px;
    position: relative;
    cursor: pointer;
  }

  .input-file {
    opacity: 0;
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

  .dropbox:hover {
    background: #e0ff23;
  }

  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
  }
  .fileAttachment {
    margin-left: 0.5em;
    margin-top: 0.5em;
    margin-right: 0.5em;
    text-align: center;
    outline: 1px solid black;
    padding: 0.25em;
    color: black;
  }
</style>



// WEBPACK FOOTER //
// src/components/GuestServices/SubmitSupportRequest/SubmitSupportRequest.vue